import React from 'react';
import BottleCounter from './components/BottleCounter';
import './App.css';

function App() {
  return (
    <div className="App">
      <BottleCounter />
    </div>
  );
}

export default App;
